<ng-template #drawerContent>
  <div class="drawer-content">
    <div class="drawer-content_deco-line"></div>
    <div class="drawer-content_header">
      <span>{{title}}</span>
      <app-button icon="close" (click)="closeDrawer()" [size]="'small'"></app-button>
    </div>
    <div class="drawer-content_panel">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>